import { render, staticRenderFns } from "./faturaheaderdialog.vue?vue&type=template&id=0095a8c4"
import script from "./faturaheaderdialog.vue?vue&type=script&lang=js"
export * from "./faturaheaderdialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports